
import { authHeader } from '../_helpers';
import axios from 'axios';

import { link } from '../_helpers'

export const userService = {
  login,
  logout,
  getAll
};

function login(data) {

  return axios.post(`/users/user-login/`, data)
    .then(handleResponse)
    .then(response => {

      localStorage.setItem('user_name', response.data.response.username);
      localStorage.setItem('usertype', response.data.usertype);
      localStorage.setItem('orgId', response.data.org_id ? response.data.org_id : null);
      localStorage.setItem('seller_id', response.data.seller_id === null ? 'null' : response.data.seller_id);

      localStorage.setItem('permissions', response.data.user_permissions);
      localStorage.setItem('is_primary_admin', response.data.is_primary_admin);
      localStorage.setItem('is_white_labeled_solution', response.data.response.is_white_labeled_solution);
      localStorage.setItem('seller_image', response.data.response.seller_image);
      localStorage.setItem('is_sign_up_completed', response.data.response.is_sign_up_completed.toString());
      localStorage.setItem('baseLink', link)
      localStorage.setItem('full_name', response.data.response.full_name);
      localStorage.setItem('short_name', response.data.response.short_name);
      localStorage.setItem('Gender', response.data.response.gender);

      var form_data = new FormData();
      const payload = {
        grant_type: 'password',
        username: data.email,
        password: data.password,
        client_id: response.data.response.auth_key.client_id,
        client_secret: response.data.response.auth_key.client_secret
      }
      const payloadForParticipant = {
        grant_type: 'password',
        auth_key: data.auth_key,
        client_id: response.data.response.auth_key.client_id,
        client_secret: response.data.response.auth_key.client_secret
      }
      if (data.auth_key) {
        localStorage.setItem('is_auth_participant', true);
        for (var key in payloadForParticipant) {
          form_data.append(key, payloadForParticipant[key]);
        }
      } else {
        localStorage.setItem('is_auth_participant', false);
        for (var key in payload) {
          form_data.append(key, payload[key]);
        }
      }

      return axios
        .post(`${link}/o/token/`, form_data)
        .then(handleResponse)
        .then((responseTokenData) => {

          localStorage.setItem(
            "access_token",
            responseTokenData.data.access_token
          );
          if (responseTokenData.data.assessment_detail) {
            localStorage.setItem(
              "assessment_completed",
              responseTokenData.data.assessment_detail
                .assessment_completed
            );
            localStorage.setItem(
              "assessment_id",
              responseTokenData.data.assessment_detail.assessment_id
            );
            localStorage.setItem(
              "organisation",
              responseTokenData.data.assessment_detail.organisation
            );
            localStorage.setItem(
              "seller",
              responseTokenData.data.assessment_detail.seller
            );
            localStorage.setItem(
              "participant__id",
              responseTokenData.data.assessment_detail.participant__id
            );
            localStorage.setItem(
              "assessment_completed_count",
              responseTokenData.data.assessment_detail
                .assessment_completed_count
            );
          }

          axios.defaults.headers.common = authHeader();
        });
    });
}

function logout() {

  localStorage.removeItem('access_token');
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

}

function handleResponse(response) {
  if (response.status === 200) {

    if (response.data.message !== undefined) {
      const error = response.data.message;
      return Promise.reject(error);
    }
    return response;
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/_services/user.service.js